import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Blog } from 'src/app/shared/models/blog';
import { BlogService } from '../blog.service';

@Component({
  selector: 'app-single-blog',
  templateUrl: './single-blog.component.html',
  styleUrls: ['./single-blog.component.scss']
})
export class SingleBlogComponent implements OnInit, OnDestroy {
  blog: Blog
  loading = true
  private subs = new Subscription()
  constructor(
    private route: ActivatedRoute,
    private blogService: BlogService
  ) { }

  ngOnInit(): void {
    const blogSlug = this.route.snapshot.params.slug
    if (blogSlug) {
      this.retrieveBlogBySlug(blogSlug)
    } else {
      const blogId = this.route.snapshot.params.id
      if (blogId) {
        this.retrieveBlogById(blogId)
      }
    }

  }

  retrieveBlogBySlug(blogSlug: string) {
    const params = { slug: blogSlug }
    this.subs.add(
      this.blogService.getBlogBySlug(params).subscribe((data: Blog) => {
        if (data) {
          this.blog = data
          this.loading = false
        }
      }, error => {
        if (error) {
          console.error(error)
        }
      })
    )
  }

  retrieveBlogById(blogId: number) {
    const params = { id: blogId }
    this.subs.add(
      this.blogService.getBlog(params).subscribe((data: Blog) => {
        if (data) {
          this.blog = data
          this.loading = false
        }
      }, error => {
        if (error) {
          console.error(error)
        }
      })
    )
  }

  ngOnDestroy() {
    this.subs.unsubscribe()
  }

}
